import { render } from "./CleanupHistory.vue?vue&type=template&id=7aaa21a9"
import script from "./CleanupHistory.vue?vue&type=script&lang=js"
export * from "./CleanupHistory.vue?vue&type=script&lang=js"
script.render = render

export default script